module.exports = __webpack_public_path__ + "static/media/traffic-moderate.842f603e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/traffic-moderate.svg
// module id = 948
// module chunks = 0